import React from "react";

import StripePaymentMethodWrapper from "./StripePaymentMethodWrapper";
import StripePaymentElements from "./StripePaymentElements";

const StripeCheckout = ({ payload = {} }) => {
  const { selectedGateway, stripeOptions } = payload;

  if (!selectedGateway) {
    return null;
  }

  return (
    <StripePaymentMethodWrapper
      key={selectedGateway._id}
      public_key={selectedGateway.stripe_publishable_key}
      options={stripeOptions}
    >
      <StripePaymentElements {...payload} gateway_id={selectedGateway._id} />
    </StripePaymentMethodWrapper>
  );
};

export default StripeCheckout;
